import { useMemo } from 'react';
import { Combobox } from '@ecargo/web-components';
import { CaseStatus, FLIGHT_CASE_LIST_STATUS_FILTER_OPTIONS } from '../../services/api/flightChanges';
import { FLIGHT_CASES_STATUS_FILTER_COMBOBOX_ID } from './flightChangesCasesFilterControlSx';
import * as S from './FlightChangesCases.styles';

export interface FlightChangesCasesStatusFilterProps {
    value: CaseStatus[];
    onChange: (next: CaseStatus[]) => void;
    t: (key: string) => string;
}

const COMBOBOX_ID = FLIGHT_CASES_STATUS_FILTER_COMBOBOX_ID;
const COMBOBOX_LABEL_ID = `${COMBOBOX_ID}-label`;

export const FlightChangesCasesStatusFilter = ({ value, onChange, t }: FlightChangesCasesStatusFilterProps) => {
    const label = t('flightChangesCases.filters.statuses');
    const placeholder = t('flightChangesCases.filters.statusesPlaceholder');

    const options = useMemo(
        () =>
            FLIGHT_CASE_LIST_STATUS_FILTER_OPTIONS.map((status) => ({
                value: status,
                label: t(status),
            })),
        [t]
    );

    /**
     * El Combobox multi de eCargo no expone `open` ni cierra al elegir; al cambiar `key`
     * se remonta el control y el menú queda cerrado sin parchear el paquete.
     */
    const comboboxRemountKey = useMemo(
        () => [...value].sort((a, b) => String(a).localeCompare(String(b))).join('|'),
        [value]
    );

    const handleChange = (next: string | string[] | null) => {
        if (next == null) {
            onChange([]);
            return;
        }
        if (Array.isArray(next)) {
            onChange(next as CaseStatus[]);
            return;
        }
        onChange([]);
    };

    return (
        <S.FilterStatusesFieldColumn data-testid="flight-cases-status-filter">
            <S.FilterLabel id={COMBOBOX_LABEL_ID} as="label" htmlFor={COMBOBOX_ID}>
                {label}
            </S.FilterLabel>
            <Combobox
                key={comboboxRemountKey}
                id={COMBOBOX_ID}
                aria-labelledby={COMBOBOX_LABEL_ID}
                label=""
                options={options}
                multiple
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                fullWidth
                size="medium"
                showStartIcon={false}
            />
        </S.FilterStatusesFieldColumn>
    );
};
